<template>
    <PopupRouterView :showLeftIcon="true" label="Picking Supply For Production Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="pickingsupplyforproduction"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="pickingSupplyForProductionInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-combobox-autocomplete :options="workOrderSupplys" optionsLabel="workOrderSupplyNumber" optionsKey="id" label-cols-lg="12" label="Work Order Supply" id="fieldset-work-order-supply" size="sm" :model.sync="model.workOrderSupplyId"   :selected="model.workOrderSupply != null ? model.workOrderSupply.workOrderSupplyNumber : ''" @input="getWorkOrderSupplys" @change="onWorkOrderSupplyChange" :isEditable="false" />
						<!-- <app-input-combobox-autocomplete :options="workOrderProcesss" optionsLabel="workOrderProcessNumber" optionsKey="id" label-cols-lg="12" label="Work Order Process" id="fieldset-work-order-process" size="sm" :model.sync="model.workOrderProcessId"   :selected="model.workOrderProcess != null ? model.workOrderProcess.workOrderProcessNumber : ''" @input="getWorkOrderProcesss" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderProcess" />
						<app-input-datetimepicker id="fieldset-work-order-supply-date" label-cols-lg="12"  label="Work Order Supply Date" size="sm" :model.sync="model.workOrderSupplyDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
						<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" />
						<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Line" id="fieldset-line" size="sm" :model.sync="model.lineId"   :selected="model.line != null ? model.line.code : ''" @input="getLines" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedLine" /> -->
					</b-col>

					<b-col cols="12">
						<app-input-textbox label="Material" id="input-picking-supply-detail-for-production-material"
							size="sm" :model.sync="filterMaterial"
							@keyupMethod="getPickingSupplyForProductionDetails(filterMaterial)" 
							/>
					</b-col>

					<b-col cols="12">
						<app-list :isDataLoading="isPickingSupplyDetailForProductionComboLoading"
							:dataCount="pickingSupplyForProductionDetails.length">
							<b-list-group-item>
								<div class="list-title" v-for="(item, index) in pickingSupplyForProductionDetails"
									@click="goToNext(2, item)">
									<b-row>
										<b-col cols="8">
											<b-row class="custom-font">
												{{ item.materialPart.partNumber }}
											</b-row>
											<b-row class="detailItem custom-font">
												{{ item.materialPart.partName }}
											</b-row>
											<b-row class="detailItem custom-font">
												{{ item.qtySupply }} (Plan)
											</b-row>
											<b-row class="detailItem custom-font">
												{{ item.qtyOutstanding }} (Remaining)
											</b-row>
										</b-col>
										<b-col cols="4" align-self="center">
											<span :class="['custom-font', getStatusClass(item.documentStatusName)]">{{
												getStatusName(item.documentStatusName) }}</span>
										</b-col>
									</b-row>
									<hr />
								</div>
							</b-list-group-item>
						</app-list>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="6"> 
						<app-input-textbox :label="'Part Number'" :model="pickingSupplyDetail != null && pickingSupplyDetail.materialPart != null ? pickingSupplyDetail.materialPart.partNumber : ''" id="input-picking-supply-detail-for-production-material"
							size="sm" :isEditable="false"/>
							<app-input-textbox :label="'Part Name'" :model="pickingSupplyDetail != null && pickingSupplyDetail.materialPart != null ? pickingSupplyDetail.materialPart.partName : ''" id="input-picking-supply-detail-for-production-material"
								size="sm" :isEditable="false"/>
					</b-col>
					<b-col cols="6">
						<app-input-textbox :label="'Plan Qty'" id="input-picking-supply-detail-for-production-material"
							size="sm" :isEditable="false"
							:model="pickingSupplyDetail != null ? pickingSupplyDetail.qtySupply : '0'"/>
							<app-input-textbox :label="'Remaining Qty'" id="input-picking-supply-detail-for-production-material"
								size="sm" :isEditable="false"
								:model="pickingSupplyDetail != null ? pickingSupplyDetail.qtyOutstanding : '0'"/>
					</b-col>
					<b-col cols="12" v-if="pickingSupplyDetail.documentStatusId != 'CLOSED'" class="mt-5">
						<app-input-scan id="fieldset-case-no" ref="fieldset-case-no" :model.sync="CaseNo"
							label="Case No" @scannedMethod="scanCase" :isBusy="isScanCaseNoLoading"
							autofocus :disabled="pickingSupplyDetail.qtyOutstanding <= 0" />
					</b-col>

					<b-col cols="12" class="mt-5">
						Suggestion List
						<div id="container-table-suggestionlist">
							<b-table id="table-list-suggestion" :class="'table-action'" head-variant="head-light" label="Picking Supply Suggestion"
								:bordered="true" :items="pickingSupplyForProductionSuggestions" :fields="fieldsPickingSupplyForProductionSuggestion" small show-empty :tbody-tr-class="rowClass">
								<template #empty>
									<!-- <app-no-data-image /> -->
								</template>
								<template v-slot:cell(receivingDate)="row">
									{{ row.item.controlCard != null ? row.item.controlCard.receivingDate : new Date() | moment("DD-MMM-YYYY HH:mm") }}
									
								</template>
							</b-table>
						</div>
					</b-col>
					
					<b-col cols="12" class="mt-5">
						Picking Case
						<div id="container-table-pickingcase">
							<b-table id="table-list-picking-case" :class="'table-action'" head-variant="head-light"
								:bordered="true" :items="pickingSupplyForProductionCases" :fields="fieldsPickingSupplyForProductionCase"  small show-empty tbody-tr-class="rowClass">
								<template v-slot:cell(frontActions)="row" >
									<b-overlay
										v-if="pickingSupplyDetail.documentStatusId != 'CLOSED'"
										:show="busy"
										rounded
										opacity="0.6"
										spinner-small
										spinner-variant="primary"
										class="d-inline-block"
										>
										<click-confirm>
										<b-button size="sm" variant="danger" @click="deleteRowDataPickingCase(row.item.id)" class="mr-2 btn-xs">
											<b-icon-trash></b-icon-trash>
										</b-button>
										</click-confirm>
									</b-overlay>
								</template>
							</b-table>
						</div>
					</b-col>

					<b-col cols="12" class="mt-4">
						<app-input-textarea id="fieldset-remark" label-cols-sm="4" label-cols-lg="3" label="Remark" label-for="filter-remark" size="sm" :model.sync="pickingSupplyDetail.remark"  @change="updateData" :isEditable="(pickingSupplyDetail.documentStatusId == 'CLOSED') ? true : true" />
					</b-col>
				</b-row>
			</span>

        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
        <template #modal-action-button>
			<b-button v-if="scanPageIndex == 1 && pickingSupplyForProductionDetails != null && pickingSupplyForProductionDetails.length > 0 && pickingSupplyForProductionDetails[0].pickingSupplyForProduction.documentStatusId!='CLOSED' && !pickingSupplyForProductionDetails.some(detail => detail.documentStatusId == 'OPEN')" size="sm" class="btn-fill-success float-right" 
				@click="saveAction()">Finish</b-button>
			<b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-primary float-right"
				@click="$router.back()">Close</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-primary float-right"
				@click="goToNext(1)">Close</b-button>
			<b-button v-if="scanPageIndex == 2 && pickingSupplyDetail.documentStatusId != 'CLOSED'" size="sm" class="btn-fill-success float-right"
				@click="saveScanCase()">Save</b-button>
			</template>

    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import PickingSupplyForProduction from '@/models/PickingSupplyForProduction/PickingSupplyForProduction';
import PickingSupplyForProductionList from '@/models/PickingSupplyForProduction/PickingSupplyForProductionList';
import PickingSupplyForProductionFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';
import WorkOrderSupplyFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyFilter';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import PickingSupplyForProductionDetail from '@/models/PickingSupplyForProduction/PickingSupplyForProductionDetail';
import PickingSupplyForProductionDetailFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionDetailFilter';
import PickingSupplyForProductionCase from '@/models/PickingSupplyForProduction/PickingSupplyForProductionCase';
import PickingSupplyForProductionCaseFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionCaseFilter';
import PickingSupplyForProductionSuggestion from '@/models/PickingSupplyForProduction/PickingSupplyForProductionSuggestion';
import PickingSupplyForProductionSuggestionFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionSuggestionFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import WorkOrderSupplyDetail from '@/models/WorkOrderSupply/WorkOrderSupplyDetail';
import WorkOrderSupplyDetailFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyDetailFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PickingSupplyForProductionDetailInput from '@/views/PickingSupplyForProduction/PickingSupplyForProductionDetailInput';
import PickingSupplyForProductionDetailScan from '@/views/PickingSupplyForProduction/PickingSupplyForProductionDetailScan';
import PickingSupplyForProductionDetailUpload from '@/views/PickingSupplyForProduction/PickingSupplyForProductionDetailUpload';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PickingSupplyForProductionCaseInput from '@/views/PickingSupplyForProduction/PickingSupplyForProductionCaseInput';
import PickingSupplyForProductionCaseScan from '@/views/PickingSupplyForProduction/PickingSupplyForProductionCaseScan';
import PickingSupplyForProductionCaseUpload from '@/views/PickingSupplyForProduction/PickingSupplyForProductionCaseUpload';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import PickingSupplyForProductionSuggestionInput from '@/views/PickingSupplyForProduction/PickingSupplyForProductionSuggestionInput';
import PickingSupplyForProductionSuggestionScan from '@/views/PickingSupplyForProduction/PickingSupplyForProductionSuggestionScan';
import PickingSupplyForProductionSuggestionUpload from '@/views/PickingSupplyForProduction/PickingSupplyForProductionSuggestionUpload';
import PopupRouterView from '@/components/PopupRouterView';
import AppSimpleTableInput from '@/components/AppSimpleTableInput';
import AppNoDataImage from '@/components/AppNoDataImage';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		AppInputTextarea,
		PickingSupplyForProductionDetailInput,
		PickingSupplyForProductionDetailScan,
		PickingSupplyForProductionDetailUpload,
		PickingSupplyForProductionCaseInput,
		PickingSupplyForProductionCaseScan,
		PickingSupplyForProductionCaseUpload,
		AppInputCheckbox,
		PickingSupplyForProductionSuggestionInput,
		PickingSupplyForProductionSuggestionScan,
		PickingSupplyForProductionSuggestionUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
		AppSimpleTableInput,
		AppNoDataImage,
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPickingSupplyForProductionDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"materialPart": { "class" : "th-material-part first-child", "label" : "Material Part", key: 'materialPart.partNumber', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part.partNumber', sortable: false}}, 
				{"qtySupply": { "class" : "th-qty-supply last-child", "label" : "Qty Supply", key: 'qtySupply', sortable: false}}, 
				{"qtyOutstanding": { "class" : "th-qty-outstanding d-stack-none", "label" : "Qty Outstanding", key: 'qtyOutstanding', sortable: false}}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: false}}, 
				{"documentStatus": { "class" : "th-document-status d-stack-none", "label" : "DocumentStatus", key: 'documentStatusName', sortable: false}}, 
				{"workOrderSupplyDetail": { "class" : "th-work-order-supply-detail d-stack-none", "label" : "Work Order Supply Detail", key: 'workOrderSupplyDetail.materialPart', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsPickingSupplyForProductionCase: [
				{"frontActions": { "class" : "th-actions", "label" : "Action"}},
				// {"no" : { "class" : "th-number d-stack-none"}}, 
				// {"pickingSupplyForProductionDetail": { "class" : "th-picking-supply-for-production-detail first-child", "label" : "Picking Supply For Production Detail", key: 'pickingSupplyForProductionDetail.materialPart', sortable: false}}, 
				{"controlCard": { "class" : "th-control-card", "label" : "Control Card", key: 'controlCard.controlCardNumber', sortable: false}}, 
				// {"part": { "class" : "th-part last-child", "label" : "Part", key: 'part.partNumber', sortable: false}}, 
				{"qty": { "class" : "th-qty d-stack-none", "label" : "Qty", key: 'qty', sortable: false}},
				{"area": { "class" : "th-control-card", "label" : "Area", key: 'controlCard.area.name', sortable: false}}, 
				{"line": { "class" : "th-control-card", "label" : "Line", key: 'controlCard.rack.line.code', sortable: false}}, 
				// {"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: false}}, 
				// {"documentStatus": { "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus.name', sortable: false}}, 
				// {"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsPickingSupplyForProductionSuggestion: [
				// {"frontActions": { "class" : "th-actions", "label" : ""}},
				// {"no" : { "class" : "th-number d-stack-none"}}, 
				// {"pickingSupplyForProductionDetail": { "class" : "th-picking-supply-for-production-detail first-child", "label" : "Picking Supply For Production Detail", key: 'pickingSupplyForProductionDetail.materialPart', sortable: false}}, 
				{"controlCard": { "class" : "th-control-card", "label" : "Case Number", key: 'controlCard.controlCardNumber', sortable: false}}, 
				{"qty": { "class" : "th-qty last-child", "label" : "Qty", key: 'qty', sortable: false}}, 
				{"rack": { "class" : "th-control-card", "label" : "Rack", key: 'controlCard.rack.code', sortable: false}}, 
				{"receivingDate": { "class" : "th-control-card", "label" : "Receiving Date", key: 'receivingDate', sortable: false}}, 
				{"area": { "class" : "th-control-card", "label" : "Area", key: 'controlCard.area.name', sortable: false}}, 
				{"line": { "class" : "th-control-card", "label" : "Line", key: 'controlCard.rack.line.code', sortable: false}}, 
				// {"isPicking": { "class" : "th-is-picking d-stack-none", "label" : "Is Picking", key: 'isPicking', sortable: false}}, 
				// {"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPickingSupplyForProductionDetail : {},
			isShowPopupPickingSupplyForProductionDetail : false,
			isShowPopupUploadPickingSupplyForProductionDetail : false,
			isShowPopupPickingSupplyForProductionDetailScan : false,
			modelPickingSupplyForProductionCase : {},
			isShowPopupPickingSupplyForProductionCase : false,
			isShowPopupUploadPickingSupplyForProductionCase : false,
			isShowPopupPickingSupplyForProductionCaseScan : false,
			modelPickingSupplyForProductionSuggestion : {},
			isShowPopupPickingSupplyForProductionSuggestion : false,
			isShowPopupUploadPickingSupplyForProductionSuggestion : false,
			isShowPopupPickingSupplyForProductionSuggestionScan : false,
			filterPickingSupplyForProduction : null,
			currentPickingSupplyForProductionPage : 1,
			pickingSupplyForProductionPageSize: 10,
			sortByPickingSupplyForProduction: '',
			sortDescPickingSupplyForProduction: '',
			filterPickingSupplyForProductionDetail : null,
			currentPickingSupplyForProductionDetailPage : 1,
			pickingSupplyForProductionDetailPageSize: 10,
			sortByPickingSupplyForProductionDetail: '',
			sortDescPickingSupplyForProductionDetail: '',
			sortingByPickingSupplyForProductionDetail: [],
			pickingSupplyForProductionDetails : [],
			pickingSupplyForProductionDetailId : '',
			totalPickingSupplyForProductionDetailRow : 0,
			isShowPickingSupplyForProductionDetailFilter: false,
			isDownloadPickingSupplyForProductionDetail: false,
			filterPickingSupplyForProductionCase : null,
			currentPickingSupplyForProductionCasePage : 1,
			pickingSupplyForProductionCasePageSize: 10,
			sortByPickingSupplyForProductionCase: '',
			sortDescPickingSupplyForProductionCase: '',
			sortingByPickingSupplyForProductionCase: [],
			pickingSupplyForProductionCases : [],
			pickingSupplyForProductionCaseId : '',
			totalPickingSupplyForProductionCaseRow : 0,
			isShowPickingSupplyForProductionCaseFilter: false,
			isDownloadPickingSupplyForProductionCase: false,
			filterPickingSupplyForProductionSuggestion : null,
			currentPickingSupplyForProductionSuggestionPage : 1,
			pickingSupplyForProductionSuggestionPageSize: 10,
			sortByPickingSupplyForProductionSuggestion: '',
			sortDescPickingSupplyForProductionSuggestion: '',
			sortingByPickingSupplyForProductionSuggestion: [],
			pickingSupplyForProductionSuggestions : [],
			pickingSupplyForProductionSuggestionId : '',
			totalPickingSupplyForProductionSuggestionRow : 0,
			isShowPickingSupplyForProductionSuggestionFilter: false,
			isDownloadPickingSupplyForProductionSuggestion: false,
			parts: [],
			documentStatuss: [],
			workOrderSupplyDetails: [],
			controlCards: [],
			workOrderSupplys: [],
			isWorkOrderSupplyComboLoading: false,
			workOrderProcesss: [],
			isWorkOrderProcessComboLoading: false,
			lines: [],
			isLineComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isWorkOrderSupplyComboLoading: false,
			isWorkOrderProcessComboLoading: false,
			isDocumentStatusComboLoading: false,
			isLineComboLoading: false,
			isPickingSupplyForProductionComboLoading: false,
			isPartComboLoading: false,
			isWorkOrderSupplyDetailComboLoading: false,
			isPickingSupplyForProductionDetailComboLoading: false,
			isControlCardComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',
			isPickingSupplyDetailForProductionComboLoading: false,
			filterMaterial: '',
			isScanCaseNoLoading: false,
			CaseNo: '',
			pickingSupplyDetail: {},
			isValidateScan: false,
			isValidateSuggestion: false,
		}
	},
	methods : {
		async deleteRowDataPickingCase(id) {
			PickingSupplyForProductionDetail.deleteDataPickingCase(this, id).then(result => { 
				this.getPickingSupplyForProductionDetail(this.pickingSupplyDetail.id);
				this.getPickingSupplyForProductionSuggestions(this.pickingSupplyDetail.id);
				this.getPickingSupplyForProductionCases();
			 });
		},
		rowClass(item) {
            return item!=null && item.isPicking == true ? 'table-success' : null;
        },
		getStatusName(status) {
			switch (status) {
				case 'OPEN':
					return 'Belum Picking';
				case 'IN PROGRESS':
					return 'Progress Picking';
				case 'CLOSED':
					return 'Finish Picking';
				default:
					return '';
			}
		},
		getStatusClass(status) {
			switch (status) {
				case 'OPEN':
					return 'text-danger';
				case 'IN PROGRESS':
					return 'text-warning';
				case 'CLOSED':
					return 'text-success';
				default:
					return '';
			}
		},
		async scanCase() {
			let qrCode = encodeURIComponent(this.CaseNo);
			await this.getControlCards(qrCode);
			
			if (this.controlCards.length == 0) {
				this.toast({message: 'Control Card Number tidak dapat ditemukan di database', title: 'Message', variant: 'danger'});
				this.CaseNo = "";
				return;
			}else if (this.controlCards.length > 0 && this.controlCards[0].areaCode != 'STORE_MATERIAL') {
				this.toast({message: 'Control Card harus berada di area STORE MATERIAL', title: 'Message', variant: 'danger'});
				this.CaseNo = "";
				return;
			}
			
			let pickingDetailId = this.pickingSupplyDetail.id;
			let controlCardId   = this.controlCards[0].id;
			this.CaseNo="";
			var validateScan = await PickingSupplyForProductionDetail.ValidateScanCase(this, pickingDetailId, controlCardId);
			if (!validateScan) {
				this.CaseNo = "";
				return;
			}

			let isConfirm = false;
			var validateSuggestion = await PickingSupplyForProductionDetail.ValidateSuggestion(this, pickingDetailId, controlCardId, isConfirm);
			if (validateSuggestion) {
				this.getPickingSupplyForProductionSuggestions(pickingDetailId);
				var addPickingCase = await PickingSupplyForProductionDetail.AddPickingCase(this, pickingDetailId, controlCardId);
				if (!addPickingCase) {
					this.CaseNo = "";
					return;
				}
	
				this.goToNext(2, this.pickingSupplyDetail);
			}else{
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Masih ada case yang tanggal penerimaannya lebih lama, apakah anda ingin tetap melanjutkan dengan case '+ this.controlCards[0].controlCardNumber +' ?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(async value => {
					if (value) {
						isConfirm = true; 
						await PickingSupplyForProductionDetail.ValidateSuggestion(this, pickingDetailId, controlCardId, isConfirm);
							
							var addPickingCase = await PickingSupplyForProductionDetail.AddPickingCase(this, pickingDetailId, controlCardId);
							if (!addPickingCase) return;
				
							this.goToNext(2, this.pickingSupplyDetail);
					}
				})
				.catch(err => {}) 
			}
			
		},
		getPickingSupplyForProduction : async function(id) {
			this.isBusy = true;
			await PickingSupplyForProduction.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPickingSupplyForProduction = true;
			this.filterPickingSupplyForProduction.id = this.modelId;
			PickingSupplyForProduction.downloadDataDetail(this, this.filterPickingSupplyForProduction).then(result => {
				this.isDownloadPickingSupplyForProduction = false;
			}).catch(error => { this.isDownloadPickingSupplyForProduction = false; })
		},
		// getPickingSupplyForProductionDetails : async function(isAddRow) {
		// 	let filter = {};
		// 	Object.assign(filter, this.filterPickingSupplyForProductionDetail);
		// 	if (this.modelId == null) return;
		// 	filter.pickingSupplyForProductionId = this.modelId;
		// 	filter.draftMode = "1";
		// 	if (this.sortByPickingSupplyForProductionDetail != null) {
		// 		this.sortingByPickingSupplyForProductionDetail[this.sortByPickingSupplyForProductionDetail] = this.sortDescPickingSupplyForProductionDetail;
		// 	}
		// 	let currentPage = (this.currentPickingSupplyForProductionDetailPage - 1);
		// 	if (isAddRow) {
		// 		let totalData = this.totalPickingSupplyForProductionDetailRow + 1;
		// 		let page = Math.ceil(totalData/this.pickingSupplyForProductionDetailPageSize);
		// 		currentPage = page - 1;
		// 	}
		// 	// disable paging start
		// 	currentPage = null;
		// 	this.pickingSupplyForProductionDetailPageSize = 0;
		// 	// disable paging end
		// 	PickingSupplyForProductionDetail.getList(this, filter, this.sortingByPickingSupplyForProductionDetail, currentPage , this.pickingSupplyForProductionDetailPageSize).then(result => {
		// 		this.currentPickingSupplyForProductionDetailPage = currentPage + 1;
		// 		this.pickingSupplyForProductionDetails = result.data.filter(obj =>
		// 			Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
		// 			);
		// 		this.pickingSupplyForProductionDetailsFiltered = result.data.filter(obj =>
		// 			Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
		// 			);
		// 		this.totalPickingSupplyForProductionDetailRow = result.dataCount;
		// 	}).catch(error => {});
		// },
		getPickingSupplyForProductionDetail : async function(id) {
			this.isBusy = true;
			await PickingSupplyForProductionDetail.getData(this, id).then(result => {
				this.pickingSupplyDetail = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getPickingSupplyForProductionDetails: async function (input) {
			let filter = new PickingSupplyForProductionDetailFilter();
			if (input != undefined || input != null) {
				filter.materialPartCombination = input;
			}
			filter.pickingSupplyForProductionId = this.modelId;
			this.isPickingSupplyDetailForProductionComboLoading = true; 
			let sortBy = Array();
			sortBy["documentstatus"] = 1;

			PickingSupplyForProductionDetail.getListByPartCombination(this, filter, sortBy, 0, 1000)
			.then(result => {
				if (result !=  null) {
					this.pickingSupplyForProductionDetails = result.data
				}
				this.isPickingSupplyDetailForProductionComboLoading = false;
			})
			.catch(error => { 
				this.isPickingSupplyDetailForProductionComboLoading = false;
			});

		},
		getPickingSupplyForProductionSuggestions : async function(id) {
			this.isShowPopupPickingSupplyForProductionSuggestion = true; 
			let pickingDetailId = this.pickingSupplyDetail.id;
			if (id != undefined || id != null) {
				pickingDetailId = id;
			}
			PickingSupplyForProductionDetail.GetSuggestionList(this, pickingDetailId).then(result => { 
				if (result != null) {
					this.pickingSupplyForProductionSuggestions = result.data
				}
				this.isShowPopupPickingSupplyForProductionSuggestion = false;
			}).catch(error => {
				this.isShowPopupPickingSupplyForProductionSuggestion = false;
			});
			
		},
		getPickingSupplyForProductionCases : async function(isAddRow) {
			if (this.modelId == null) return;
			this.isShowPopupPickingSupplyForProductionCase = true;

			PickingSupplyForProductionDetail.GetPickingCaseList(this, this.modelId, this.pickingSupplyDetail.id).then(result => { 
				if (result != null) {
					this.pickingSupplyForProductionCases = result
				}
				this.isShowPopupPickingSupplyForProductionCase = false;
			}).catch(error => {
				this.isShowPopupPickingSupplyForProductionCase = false;
			});
		},
		// getPickingSupplyForProductionSuggestions : async function(isAddRow) {
		// 	let filter = {};
		// 	Object.assign(filter, this.filterPickingSupplyForProductionSuggestion);
		// 	if (this.modelId == null) return;
		// 	filter.pickingSupplyForProductionId = this.modelId;
		// 	filter.draftMode = "1";
		// 	if (this.sortByPickingSupplyForProductionSuggestion != null) {
		// 		this.sortingByPickingSupplyForProductionSuggestion[this.sortByPickingSupplyForProductionSuggestion] = this.sortDescPickingSupplyForProductionSuggestion;
		// 	}
		// 	let currentPage = (this.currentPickingSupplyForProductionSuggestionPage - 1);
		// 	if (isAddRow) {
		// 		let totalData = this.totalPickingSupplyForProductionSuggestionRow + 1;
		// 		let page = Math.ceil(totalData/this.pickingSupplyForProductionSuggestionPageSize);
		// 		currentPage = page - 1;
		// 	}
		// 	// disable paging start
		// 	currentPage = null;
		// 	this.pickingSupplyForProductionSuggestionPageSize = 0;
		// 	// disable paging end
		// 	PickingSupplyForProductionSuggestion.getList(this, filter, this.sortingByPickingSupplyForProductionSuggestion, currentPage , this.pickingSupplyForProductionSuggestionPageSize).then(result => {
		// 		this.currentPickingSupplyForProductionSuggestionPage = currentPage + 1;
		// 		this.pickingSupplyForProductionSuggestions = result.data.filter(obj =>
		// 			Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
		// 			);
		// 		this.pickingSupplyForProductionSuggestionsFiltered = result.data.filter(obj =>
		// 			Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
		// 			);
		// 		this.totalPickingSupplyForProductionSuggestionRow = result.dataCount;
		// 	}).catch(error => {});
		// },
		getPickingSupplyForProductions : async function(input) {
			let filter = new PickingSupplyForProductionFilter();
			if (input != undefined) {
				filter.workOrderSupply = input;
			}
			this.isPickingSupplyForProductionComboLoading = true;
			PickingSupplyForProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForProductions = result.data
				}
				this.isPickingSupplyForProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			await Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDocumentStatusComboLoading = true;
			await DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
				this.isDocumentStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderSupplyDetails : async function(input) {
			let filter = new WorkOrderSupplyDetailFilter();
			if (input != undefined) {
				filter.materialPart = input;
			}
			this.isWorkOrderSupplyDetailComboLoading = true;
			await WorkOrderSupplyDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplyDetails = result.data
				}
				this.isWorkOrderSupplyDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			filter.exactType.controlCardNumber = '1';
			this.isControlCardComboLoading = true;
			await ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderSupplys : async function(input) {
			let filter = new WorkOrderSupplyFilter();
			if (input != undefined) {
				filter.workOrderSupplyDate = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			await WorkOrderSupply.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderSupplyExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.workOrderSupplyId = null;
				this.model.workOrderSupply = null;
				this.isBusy = true;
				PickingSupplyForProduction.resetDocument(this, this.model.id).then(result => {
					this.getPickingSupplyForProduction(this.model.id).then(result => {
						this.getPickingSupplyForProductionDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.workOrderSupplyId = item.id;
				this.model.workOrderSupply = item;

				this.isBusy = true;
				PickingSupplyForProduction.copyFromDocument(this, 'workordersupply', item.id, this.model.id).then(result => {
					this.getPickingSupplyForProduction(this.model.id).then(result => {
						this.getPickingSupplyForProductionDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedWorkOrderSupply(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.workOrderSupplyId == itemId) return;
			}

			if(this.pickingSupplyForProductionDetails != null && this.pickingSupplyForProductionDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Picking Supply For Production akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedWorkOrderSupplyExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedWorkOrderSupplyExecuted(item);
			}
		},
		onWorkOrderSupplyChange : async function() {
			this.model.workOrderProcessId = null;
			this.model.workOrderProcess = null;

			let item = this.model.workOrderSupplyId;
			let workOrderSupplyObj = this.workOrderSupplys.filter(function(workOrderSupply){ return workOrderSupply.id == item; });
			this.model.workOrderSupply = workOrderSupplyObj.length > 0 ? workOrderSupplyObj[0] : null;
			this.getWorkOrderProcessByWorkOrderSupply();
		},
		getWorkOrderProcessByWorkOrderSupply : async function(input) {
			this.workOrderProcessState = false;
			this.$forceUpdate();

			let filter = new WorkOrderProcessFilter();
			filter.workOrderSupplyId = this.model.workOrderSupplyId;
			if (input != undefined) {
				filter.workOrderSupplyDate = input;
			}
			if (filter.workOrderSupplyId === undefined || filter.workOrderSupplyId === null || filter.workOrderSupplyId === '') {
				this.workOrderProcesss = [];
			} else {
				await WorkOrderProcess.getList(this, filter, null, 0, 10)
					.then(result => {
						this.workOrderProcesss = [];
						if (result != null) {
							this.workOrderProcesss = result.data
						}
					})
					.catch(error => {
						this.workOrderProcesss = [];
					});
			}

			this.workOrderProcessState = true;
			this.$forceUpdate();
		},

		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			await WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcess(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessId = null;
				this.model.workOrderProcess = null;
			} else {
				this.model.workOrderProcessId = item.id;
				this.model.workOrderProcess = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedLine(item) {
			if(item == undefined || item == null) {
				this.model.lineId = null;
				this.model.line = null;
			} else {
				this.model.lineId = item.id;
				this.model.line = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.pickingSupplyForProductionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			const isDocumentNotClosed = this.pickingSupplyForProductionDetails.some(item => item.documentStatusId !== 'CLOSED');

			if (isDocumentNotClosed) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						// innerHTML: '<p>Masih ada material yang belum memenuhi qty yang perlu disupply, apakah anda ingin melanjutkan ?</p>'
						innerHTML: '<p>Apakah anda yakin ingin menyelesaikan proses picking dari Work Order Supply ' + this.model.workOrderSupply.workOrderSupplyNumber + ' ?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(async value => {
					if (value) {
						let this_ = this;
						this_.isBusy = true;
						let id = this.modelId;
						this_.$http.post('PickingSupplyForProduction/finishScanCase/' + id)
						.then(async function(response){
							this_.isDataCommited = true;
							this_.$router.push({ name: 'pickingsupplyforproductionindex' });
							this_.isBusy = false;
						})
						.catch(function(error){
							this_.isBusy = false;
							if (error.response && error.response.data && error.response.data.errors) {
								const errors = error.response.data.errors;
								// Iterasi melalui setiap pesan kesalahan
								Object.keys(errors).forEach(key => {
									const errorMessages = errors[key];
									errorMessages.forEach(errorMessage => {
										// Tampilkan pesan kesalahan dalam toast
										this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
									});
								});
							}
							// this_.$store.dispatch('addErrorMessageGlobal', error);
							// throw error;
						});
					}
				})
				.catch(err => {})
			}else{
				let this_ = this;
				this_.isBusy = true;
				let id = this.modelId;
				this_.$http.post('PickingSupplyForProduction/finishScanCase/' + id)
				.then(async function(response){
					this_.isDataCommited = true;
					if (response.status == 201 || response.status == 204) {
						this_.$router.push({ name: 'pickingsupplyforproductionindex' });
					}
					this_.isBusy = false;
				})
				.catch(function(error){
					this_.isBusy = false;
					if (error.response && error.response.data && error.response.data.errors) {
						const errors = error.response.data.errors;
						// Iterasi melalui setiap pesan kesalahan
						Object.keys(errors).forEach(key => {
							const errorMessages = errors[key];
							errorMessages.forEach(errorMessage => {
								// Tampilkan pesan kesalahan dalam toast
								this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
							});
						});
					}
					// this_.$store.dispatch('addErrorMessageGlobal', error);
					// throw error;
				});
			} 
			
		},
		async saveScanCase(modalEvent) {
			await this.updateData();
			let this_ = this;
			this_.isBusy = true;
			let id = this.pickingSupplyDetail.id;
			await this_.$http.post('PickingSupplyForProductionDetail/saveScanCase/' + id)
			.then(async function(response){
				this_.isDataCommited = true;
				this_.isBusy = false;
				await this_.goToNext(1);
				
			})
			.catch(function(error){
				this_.isBusy = false;
				if (error.response && error.response.data && error.response.data.errors) {
					const errors = error.response.data.errors;
					// Iterasi melalui setiap pesan kesalahan
					Object.keys(errors).forEach(key => {
						const errorMessages = errors[key];
						errorMessages.forEach(errorMessage => {
							// Tampilkan pesan kesalahan dalam toast
							this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
						});
					});
				}
				// this_.$store.dispatch('addErrorMessageGlobal', error);
				// throw error;
			});
		},
		updateData() {
			let id = this.pickingSupplyDetail.id;
			let model = this.pickingSupplyDetail;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return PickingSupplyForProductionDetail.updateData(this, model, id)
					.catch((error) => {
						return this.getPickingSupplyForProductionDetail(id);
					});
				}
				return false;
			});
		},
		onHidden() {
			this.getPickingSupplyForProductions();
		},
		addRowDataPickingSupplyForProductionDetail(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPickingSupplyForProductionDetails(true);
						this.isShowPopupPickingSupplyForProductionDetail = false;
					})
				} else {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionDetail.createDataDetail(this, model)
					.then(result => {
						this.getPickingSupplyForProductionDetails(true);
						this.isShowPopupPickingSupplyForProductionDetail = false;
					})
				}
			}
		},
		async editRowDataPickingSupplyForProductionDetail(id) {
			this.pickingSupplyForProductionDetailId = id;
			this.isShowPopupPickingSupplyForProductionDetail = true; 
		},
		async deleteRowDataPickingSupplyForProductionDetail(id) {
			PickingSupplyForProductionDetail.deleteData(this, id).then(result => { this.getPickingSupplyForProductionDetails(); });
		},
		async resetDataPickingSupplyForProductionDetail() {
			this.pickingSupplyForProductionDetailId = "";
			this.isShowPopupPickingSupplyForProductionDetail = true;
		},
		async addDataPickingSupplyForProductionDetail() {
			PickingSupplyForProductionDetail.createData(this, { pickingSupplyForProductionId: this.modelId })
			.then(result => {
				this.getPickingSupplyForProductionDetails(true);
			})
		},
		async addFromClipboardPickingSupplyForProductionDetail() {
			let materialParts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					materialParts.push({ materialPart: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionDetail.addFromClipboard(this, materialParts).then(result => { this.getPickingSupplyForProductionDetails() });
			});
		},
		async replaceFromClipboardPickingSupplyForProductionDetail() {
			let materialParts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					materialParts.push({ materialPart: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionDetail.replaceFromClipboard(this, materialParts).then(result => { this.getPickingSupplyForProductionDetails() });
			});   
		},
		showPopupUploadPickingSupplyForProductionDetail() {
			this.isShowPopupUploadPickingSupplyForProductionDetail = true;
		},
		uploadDataPickingSupplyForProductionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPickingSupplyForProductionDetail = false; 
		},
		downloadPickingSupplyForProductionDetail(modalEvent) {
			this.isDownloadPickingSupplyForProductionDetail = true;
			this.filterPickingSupplyForProductionDetail.pickingSupplyForProductionId = this.modelId;
			PickingSupplyForProductionDetail.downloadDataDetail(this, this.filterPickingSupplyForProductionDetail).then(result => {
				this.isDownloadPickingSupplyForProductionDetail = false;
			}).catch(error => { this.isDownloadPickingSupplyForProductionDetail = false; })
		},
		saveInputPickingSupplyForProductionDetail(item) {
			if (this.pickingSupplyForProductions != null && this.pickingSupplyForProductions != undefined  && this.pickingSupplyForProductions.length > 0) {
				item.pickingSupplyForProduction = this.pickingSupplyForProductions.find(q => q.id == item.pickingSupplyForProductionId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.materialPart = this.parts.find(q => q.id == item.materialPartId);
			}
			if (this.documentStatuss != null && this.documentStatuss != undefined  && this.documentStatuss.length > 0) {
				item.documentStatus = this.documentStatuss.find(q => q.id == item.documentStatusId);
			}
			if (this.workOrderSupplyDetails != null && this.workOrderSupplyDetails != undefined  && this.workOrderSupplyDetails.length > 0) {
				item.workOrderSupplyDetail = this.workOrderSupplyDetails.find(q => q.id == item.workOrderSupplyDetailId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingSupplyForProductionDetail.updateData(this, item, item.id);
				}
			});
		},
		addRowDataPickingSupplyForProductionCase(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionCase.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPickingSupplyForProductionCases(true);
						this.isShowPopupPickingSupplyForProductionCase = false;
					})
				} else {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionCase.createDataDetail(this, model)
					.then(result => {
						this.getPickingSupplyForProductionCases(true);
						this.isShowPopupPickingSupplyForProductionCase = false;
					})
				}
			}
		},
		async editRowDataPickingSupplyForProductionCase(id) {
			this.pickingSupplyForProductionCaseId = id;
			this.isShowPopupPickingSupplyForProductionCase = true; 
		},
		async deleteRowDataPickingSupplyForProductionCase(id) {
			PickingSupplyForProductionCase.deleteData(this, id).then(result => { this.getPickingSupplyForProductionCases(); });
		},
		async resetDataPickingSupplyForProductionCase() {
			this.pickingSupplyForProductionCaseId = "";
			this.isShowPopupPickingSupplyForProductionCase = true;
		},
		async addDataPickingSupplyForProductionCase() {
			PickingSupplyForProductionCase.createData(this, { pickingSupplyForProductionId: this.modelId })
			.then(result => {
				this.getPickingSupplyForProductionCases(true);
			})
		},
		async addFromClipboardPickingSupplyForProductionCase() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionCase.addFromClipboard(this, controlCards).then(result => { this.getPickingSupplyForProductionCases() });
			});
		},
		async replaceFromClipboardPickingSupplyForProductionCase() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionCase.replaceFromClipboard(this, controlCards).then(result => { this.getPickingSupplyForProductionCases() });
			});   
		},
		showPopupUploadPickingSupplyForProductionCase() {
			this.isShowPopupUploadPickingSupplyForProductionCase = true;
		},
		uploadDataPickingSupplyForProductionCase(modalEvent, newDatas) {
			this.isShowPopupUploadPickingSupplyForProductionCase = false; 
		},
		downloadPickingSupplyForProductionCase(modalEvent) {
			this.isDownloadPickingSupplyForProductionCase = true;
			this.filterPickingSupplyForProductionCase.pickingSupplyForProductionId = this.modelId;
			PickingSupplyForProductionCase.downloadDataDetail(this, this.filterPickingSupplyForProductionCase).then(result => {
				this.isDownloadPickingSupplyForProductionCase = false;
			}).catch(error => { this.isDownloadPickingSupplyForProductionCase = false; })
		},
		saveInputPickingSupplyForProductionCase(item) {
			if (this.pickingSupplyForProductionDetails != null && this.pickingSupplyForProductionDetails != undefined  && this.pickingSupplyForProductionDetails.length > 0) {
				item.pickingSupplyForProductionDetail = this.pickingSupplyForProductionDetails.find(q => q.id == item.pickingSupplyForProductionDetailId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingSupplyForProductionCase.updateData(this, item, item.id);
				}
			});
		},
		addRowDataPickingSupplyForProductionSuggestion(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionSuggestion.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPickingSupplyForProductionSuggestions(true);
						this.isShowPopupPickingSupplyForProductionSuggestion = false;
					})
				} else {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionSuggestion.createDataDetail(this, model)
					.then(result => {
						this.getPickingSupplyForProductionSuggestions(true);
						this.isShowPopupPickingSupplyForProductionSuggestion = false;
					})
				}
			}
		},
		async editRowDataPickingSupplyForProductionSuggestion(id) {
			this.pickingSupplyForProductionSuggestionId = id;
			this.isShowPopupPickingSupplyForProductionSuggestion = true; 
		},
		async deleteRowDataPickingSupplyForProductionSuggestion(id) {
			PickingSupplyForProductionSuggestion.deleteData(this, id).then(result => { this.getPickingSupplyForProductionSuggestions(); });
		},
		async resetDataPickingSupplyForProductionSuggestion() {
			this.pickingSupplyForProductionSuggestionId = "";
			this.isShowPopupPickingSupplyForProductionSuggestion = true;
		},
		async addDataPickingSupplyForProductionSuggestion() {
			PickingSupplyForProductionSuggestion.createData(this, { pickingSupplyForProductionId: this.modelId })
			.then(result => {
				this.getPickingSupplyForProductionSuggestions(true);
			})
		},
		async addFromClipboardPickingSupplyForProductionSuggestion() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionSuggestion.addFromClipboard(this, controlCards).then(result => { this.getPickingSupplyForProductionSuggestions() });
			});
		},
		async replaceFromClipboardPickingSupplyForProductionSuggestion() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionSuggestion.replaceFromClipboard(this, controlCards).then(result => { this.getPickingSupplyForProductionSuggestions() });
			});   
		},
		showPopupUploadPickingSupplyForProductionSuggestion() {
			this.isShowPopupUploadPickingSupplyForProductionSuggestion = true;
		},
		uploadDataPickingSupplyForProductionSuggestion(modalEvent, newDatas) {
			this.isShowPopupUploadPickingSupplyForProductionSuggestion = false; 
		},
		downloadPickingSupplyForProductionSuggestion(modalEvent) {
			this.isDownloadPickingSupplyForProductionSuggestion = true;
			this.filterPickingSupplyForProductionSuggestion.pickingSupplyForProductionId = this.modelId;
			PickingSupplyForProductionSuggestion.downloadDataDetail(this, this.filterPickingSupplyForProductionSuggestion).then(result => {
				this.isDownloadPickingSupplyForProductionSuggestion = false;
			}).catch(error => { this.isDownloadPickingSupplyForProductionSuggestion = false; })
		},
		saveInputPickingSupplyForProductionSuggestion(item) {

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingSupplyForProductionSuggestion.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPickingSupplyForProductionDetail = false; 
			this.isShowPopupPickingSupplyForProductionDetail = false; 
			if (modalType == 'PickingSupplyForProductionDetail') {
				this.getPickingSupplyForProductionDetails();
			}
			this.isShowPopupUploadPickingSupplyForProductionCase = false; 
			this.isShowPopupPickingSupplyForProductionCase = false; 
			if (modalType == 'PickingSupplyForProductionCase') {
				this.getPickingSupplyForProductionCases();
			}
			this.isShowPopupUploadPickingSupplyForProductionSuggestion = false; 
			this.isShowPopupPickingSupplyForProductionSuggestion = false; 
			if (modalType == 'PickingSupplyForProductionSuggestion') {
				this.getPickingSupplyForProductionSuggestions();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
			this.CaseNo = '';
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		async goToNext(page, item) {
			if(page == 1) {
				let id = this.modelId;
				await this.getPickingSupplyForProduction(id);
				await this.getPickingSupplyForProductionDetails();
				this.scanPageIndex = page;
				return;
			}

			if(page == 2) {
				await this.getPickingSupplyForProductionDetail(item.id);
				await this.getPickingSupplyForProductionSuggestions(item.id);
				await this.getPickingSupplyForProductionCases();
				this.scanPageIndex = page;
				return;
			}
		},
	},
	beforeMount() {
		this.filterPickingSupplyForProduction = new PickingSupplyForProductionFilter();
		this.filterPickingSupplyForProductionDetail = new PickingSupplyForProductionDetailFilter();
		this.filterPickingSupplyForProductionCase = new PickingSupplyForProductionCaseFilter();
		this.filterPickingSupplyForProductionSuggestion = new PickingSupplyForProductionSuggestionFilter();
		//this.getPickingSupplyForProductions();
		//this.getParts();
		//this.getDocumentStatuss();
		//this.getWorkOrderSupplyDetails();
		//this.getPickingSupplyForProductionDetails();
		//this.getControlCards();
		//this.getWorkOrderSupplys();
		//this.getWorkOrderProcesss();
		//this.getLines();
	},
	async mounted(){
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getPickingSupplyForProduction(id);
			this.getPickingSupplyForProductionDetails();
		}
		this.$nextTick(() => {
			
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>

<style scoped>
.table-row-ispicking {
    background-color: #20c926;
}
.detailItem {
	color:black!important;
	font-size: 20px;
}
.custom-font {
	font-size: 16px;
}

#container-table-suggestionlist {
	max-height: 200px;
	overflow-y: auto;
	width: 100%;
	overflow-x: auto;
}

#container-table-pickingcase {
	max-height: 200px;
	overflow-y: auto;
	width: 100%;
	overflow-x: auto;
}
</style>
